module.exports = __webpack_public_path__ + "img/customize_want.eabf758f.svg";